import { createReducer } from 'redux-act';

import {
  SLIDE_SHOW_FETCH_DATA_INIT,
  SLIDE_SHOW_FETCH_DATA_SUCCESS,
  SLIDE_SHOW_FETCH_DATA_FAIL,
  SLIDE_SHOW_DELETE_INIT,
  SLIDE_SHOW_DELETE_SUCCESS,
  SLIDE_SHOW_DELETE_FAIL,
  SLIDE_SHOW_CLEAR_DATA,
  SLIDE_SHOW_CREATE_INIT,
  SLIDE_SHOW_CREATE_SUCCESS,
  SLIDE_SHOW_CREATE_FAIL,
  SLIDE_SHOW_MODIFY_INIT,
  SLIDE_SHOW_MODIFY_SUCCESS,
  SLIDE_SHOW_MODIFY_FAIL,
  SLIDE_SHOW_CLEAN_UP,
  SLIDE_SHOW_CLEAR_DATA_LOGOUT
} from '../../actions/slideShows';

const initialState = {
  data: [],
  loading: false,
  error: null,
  success: false,
  deleted: false
};

export const slideShowsReducer = createReducer(
  {
    [SLIDE_SHOW_FETCH_DATA_INIT]: () => ({
      ...initialState,
      loading: true
    }),
    [SLIDE_SHOW_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      data: payload.slideShows,
      loading: false,
      error: null
    }),
    [SLIDE_SHOW_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [SLIDE_SHOW_DELETE_INIT]: state => ({
      ...state,
      loading: true
    }),
    [SLIDE_SHOW_DELETE_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.filter(elem => elem.id !== payload.id),
      loading: false,
      error: null,
      deleted: true
    }),
    [SLIDE_SHOW_DELETE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [SLIDE_SHOW_CLEAR_DATA]: state => ({
      ...initialState,
      data: state.data
    }),
    [SLIDE_SHOW_CREATE_INIT]: state => ({
      ...state,
      loading: true
    }),
    [SLIDE_SHOW_CREATE_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.concat(payload),
      loading: false,
      error: null,
      success: true
    }),
    [SLIDE_SHOW_CREATE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [SLIDE_SHOW_MODIFY_INIT]: state => ({
      ...state,
      loading: true
    }),
    [SLIDE_SHOW_MODIFY_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.map(elem => {
        if (elem.id === payload.id) {
          return payload;
        }
        return elem;
      }),
      loading: false,
      error: null,
      success: true
    }),
    [SLIDE_SHOW_MODIFY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [SLIDE_SHOW_CLEAN_UP]: state => ({
      ...state,
      loading: false,
      error: null,
      success: false,
      deleted: false
    }),
    [SLIDE_SHOW_CLEAR_DATA_LOGOUT]: () => ({
      ...initialState
    })
  },
  initialState
);
